<template>
    <div v-if="parseFloat(cost) > 0" class="col-md-12 col-sm-12 col-xs-12 text-center" style="margin-bottom: 15px;">
      Стоимость услуг по заявке составляет <b>{{cost.toLocaleString('ru')}} тенге</b> с НДС
    </div>
</template>

<script>
export default {
  name: 'ApplicationCost',
  props: {
    cost: {}
  }
}
</script>
